import { useSyncProgress } from "./mud/useSyncProgress";
import { useAccount } from "wagmi";

import "./App.css";
import "@rainbow-me/rainbowkit/styles.css";

import { EveAlert } from "@eveworld/ui-components";
import { useNotification, useSmartObject } from "@eveworld/contexts";

import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useSearchParams,
} from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import globalTheme from "./globalTheme";

import Home from "./components/Home";
import Admin from "./components/Admin";
import TribeMember from "./components/TribeMember";
import Unauthorized from "./components/Unauthorized";
import NotFound from "./components/NotFound";
import Recruit from "./components/Recruit";
import { TabsMenu } from "./components/TabsMenu";

import InitVars from "./InitVars";
import RecruitOnly from "./components/RecruitOnly";
import Officer from "./components/Officer";

export const App = () => {
  const { isLive, message, percentage } = useSyncProgress();
  const { smartCharacter } = useSmartObject();
  const { chain } = useAccount();
  const { notification } = useNotification();

  const [searchParams, setSearchParams] = useSearchParams();
  searchParams.get("calledfromef=true");

  if (
    InitVars.calledFromEF == false &&
    searchParams.toString() == "calledfromef=true"
  ) {
    InitVars.calledFromEF = true;
  }

  return (
    <>
      <EveAlert
        message={notification.message}
        severity={notification.severity}
        handleClose={notification.handleClose}
        isOpen={notification.isOpen}
        isStyled={false}
        blockExplorer={chain?.blockExplorers?.default?.url}
        txHash={notification.txHash}
      />
      <ThemeProvider theme={globalTheme}>
        <CssBaseline />

        {isLive ? (
          <>
            <div className="header">
              {location.pathname === "/recruitonly" ? (
                <></>
              ) : (
                <TabsMenu></TabsMenu>
              )}
            </div>
            <div className="layout">
              <Routes>
                <Route path="/" element={<Home />}></Route>
                <Route path="/unauthorized" element={<Unauthorized />}></Route>
                <Route path="/recruit" element={<Recruit />}></Route>
                <Route path="/recruitonly" element={<RecruitOnly />}></Route>
                {/* <Route element={<RoleAccess roles={["CorpRider", "Admin"]} />}> */}
                {/* <Route path="/tribemember" element={<TribeMember />} /> */}
                <Route path="/tribemember" element={<TribeMember />} />
                {/* <Route path="/toggle" element={<Toggle />} /> */}
                {/* </Route> */}
                {/* <Route element={<RoleAccess roles={["Admin"]} />}> */}
                <Route path="/admin" element={<Admin />} />
                <Route path="/officer" element={<Officer />} />
                {/* <Route path="/testpage" element={<TestPage />} /> */}
                {/* </Route> */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
          </>
        ) : (
          <div className="tabular-nums">
            {message} ({percentage.toFixed(1)}%)
          </div>
        )}
      </ThemeProvider>
    </>
  );
};
